import './index.scss';
import React, { PropTypes }  from 'react';
import ourPropTypes from '../../../js/ourPropTypes';
import { operationTypeToNoun } from '../../../js/operationTypes';
import Shiitake from 'shiitake';

const OperationFailureMessage = React.createClass({
    propTypes: {
        operation: ourPropTypes.operation
    },
    render: function () {
        const operation = this.props.operation;

        return (<div className="pure-u-1-1 operation-failure-message" title={operation.lastError ? operation.lastError.message : ''}>
            <div className="error-message">
                    <span className="icon icon--warning-octagon"></span>
                    <span>{operationTypeToNoun(operation.type)} failed</span>
            </div>
            {operation.lastError && <Shiitake lines={2}>{operation.lastError.message}</Shiitake>}
        </div>);
    }
});

export default OperationFailureMessage;



// WEBPACK FOOTER //
// ./src/components/common/OperationFailureMessage/index.jsx